module.exports = __webpack_public_path__ + "static/img/TOP.7cfed67.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/TOP.png
// module id = gbB8
// module chunks = 0